<!-- <div id="mauticform_wrapper_enviaremailrecuperarsenha2" class="mauticform_wrapper">
    <form autocomplete="false" role="form" method="post" action="{{formApiUrl}}?formId=4"
        id="mauticform_enviaremailrecuperarsenha2" data-mautic-form="enviaremailrecuperarsenha2"
        enctype="multipart/form-data" #form>
        <div class="mauticform-error" id="mauticform_enviaremailrecuperarsenha2_error"></div>
        <div class="mauticform-message" id="mauticform_enviaremailrecuperarsenha2_message"></div>
        <div class="mauticform-innerform">

            
          <div class="mauticform-page-wrapper mauticform-page-1" data-mautic-form-page="1">

            <div id="mauticform_enviaremailrecuperarsenha2_email" data-validate="email" data-validation-type="email" class="mauticform-row mauticform-email mauticform-field-1 mauticform-required">
                <input id="mauticform_input_enviaremailrecuperarsenha2_email" name="mauticform[email]" 
                [value]="formData.email" class="mauticform-input" type="email">
                </div>

            <div id="mauticform_enviaremailrecuperarsenha2_url" data-validate="url" data-validation-type="url" class="mauticform-row mauticform-url mauticform-field-2 mauticform-required">
                <input id="mauticform_input_enviaremailrecuperarsenha2_url" name="mauticform[url]" 
                [value]="formData.url" class="mauticform-input" type="url">
            </div>

            <div id="mauticform_enviaremailrecuperarsenha2_token" data-validate="token" data-validation-type="text" class="mauticform-row mauticform-text mauticform-field-3 mauticform-required">
                <input id="mauticform_input_enviaremailrecuperarsenha2_token" name="mauticform[token]" 
                [value]="formData.token" class="mauticform-input" type="text">
            </div>

            <div id="mauticform_enviaremailrecuperarsenha2_submit" class="mauticform-row mauticform-button-wrapper mauticform-field-4">
                <button type="submit" name="mauticform[submit]" id="mauticform_input_enviaremailrecuperarsenha2_submit" value="" class="mauticform-button btn btn-default">Submit</button>
            </div>
            </div>
        </div>

        <input type="hidden" name="mauticform[formId]" id="mauticform_enviaremailrecuperarsenha2_id" value="26">
        <input type="hidden" name="mauticform[return]" id="mauticform_enviaremailrecuperarsenha2_return" value="">
        <input type="hidden" name="mauticform[formName]" id="mauticform_enviaremailrecuperarsenha2_name" value="enviaremailrecuperarsenha2">

    </form>

</div> -->

<div id="mauticform_wrapper_resetasenha" class="mauticform_wrapper">
  <form
    autocomplete="false"
    role="form"
    method="post"
    action="{{ formApiUrl }}?formId=5"
    id="mauticform_resetasenha"
    data-mautic-form="resetasenha"
    enctype="multipart/form-data"
    #form
  >
    <div class="mauticform-error" id="mauticform_resetasenha_error"></div>
    <div class="mauticform-message" id="mauticform_resetasenha_message"></div>
    <div class="mauticform-innerform">
      <div
        class="mauticform-page-wrapper mauticform-page-1"
        data-mautic-form-page="1"
      >
        <div
          id="mauticform_resetasenha_email"
          data-validate="email"
          data-validation-type="email"
          class="mauticform-row mauticform-email mauticform-field-1 mauticform-required"
        >
          <input
            id="mauticform_input_resetasenha_email"
            name="mauticform[email]"
            [value]="formData.email"
            class="mauticform-input"
            type="email"
          />
        </div>

        <div
          id="mauticform_resetasenha_token"
          data-validate="token"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-2 mauticform-required"
        >
          <input
            id="mauticform_input_resetasenha_token"
            name="mauticform[token]"
            [value]="formData.token"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_resetasenha_senha"
          data-validate="senha"
          data-validation-type="text"
          class="mauticform-row mauticform-text mauticform-field-3 mauticform-required"
        >
          <input
            id="mauticform_input_resetasenha_senha"
            name="mauticform[senha]"
            [value]="formData.url"
            class="mauticform-input"
            type="text"
          />
        </div>

        <div
          id="mauticform_resetasenha_submit"
          class="mauticform-row mauticform-button-wrapper mauticform-field-4"
        >
          <button
            type="submit"
            name="mauticform[submit]"
            id="mauticform_input_resetasenha_submit"
            value=""
            class="mauticform-button btn btn-default"
          >
            Submit
          </button>
        </div>
      </div>
    </div>

    <input
      type="hidden"
      name="mauticform[formId]"
      id="mauticform_resetasenha_id"
      value="5"
    />
    <input
      type="hidden"
      name="mauticform[return]"
      id="mauticform_resetasenha_return"
      value=""
    />
    <input
      type="hidden"
      name="mauticform[formName]"
      id="mauticform_resetasenha_name"
      value="resetasenha"
    />
  </form>
</div>
